import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
export function getContentStyle(alignContent, verticalAlign) {
  var style = {
    display: 'flex'
  };
  var alignContentStyle = {
    center: {
      textAlign: 'center',
      justifyContent: 'center'
    },
    left: {
      textAlign: 'left',
      justifyContent: 'left'
    },
    right: {
      textAlign: 'right',
      justifyContent: 'right'
    }
  };
  var verticalAlignStyle = {
    top: {
      alignItems: 'flex-start'
    },
    middle: {
      alignItems: 'center'
    },
    bottom: {
      alignItems: 'flex-end'
    }
  };
  style = _objectSpread(_objectSpread({}, style), alignContentStyle[alignContent]);
  style = _objectSpread(_objectSpread({}, style), verticalAlignStyle[verticalAlign]);
  return style;
}